var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBonfire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.871,
    height: 114.904,
    viewBox: "0 0 114.871 114.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1.024,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-bonfire",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    "data-name": "Caminho 543",
    className: "cls-1",
    d: "M0,106.826V8.136c.094-.273.206-.542.28-.82A9.513,9.513,0,0,1,8.65.125c2.043-.166,4.108-.061,6.164-.061,2.813,0,4.3,1.466,4.309,4.266.013,3.252,0,6.5,0,9.753v1.207H95.74V14.028c0-3.364-.02-6.727.012-10.089A3.6,3.6,0,0,1,98.988.133,41.9,41.9,0,0,1,106.6.209c5.078.662,8.266,4.65,8.267,9.943q0,45.851,0,91.7c0,1.234.02,2.468-.01,3.7a9.581,9.581,0,0,1-6.365,8.788c-.629.221-1.283.376-1.924.562H8.3c-.282-.081-.562-.166-.845-.241a9.537,9.537,0,0,1-7.012-6.49C.29,107.724.147,107.274,0,106.826Zm95.74-87.56H19.126V95.119c0,3.033-1.445,4.477-4.451,4.49-1.832.007-3.667-.043-5.494.043a5.778,5.778,0,0,0-5.055,4,5.415,5.415,0,0,0,1.6,5.915,6.2,6.2,0,0,0,4.548,1.52q41.216-.022,82.431-.01c4.187,0,8.375.028,12.56-.01a5.745,5.745,0,0,0,5.774-5.662,5.876,5.876,0,0,0-5.691-5.782c-1.606-.049-3.215-.016-4.821-.018-3.476,0-4.785-1.321-4.785-4.826V19.269ZM3.822,97.849c3.588-2.837,7.587-1.845,11.41-2.123V3.883H10.374c-4.3,0-6.553,2.265-6.553,6.576v87.39ZM99.649,3.9V95.742c3.884.221,7.885-.69,11.4,2.064V10.415c0-.374.01-.748-.015-1.12a5.679,5.679,0,0,0-5.237-5.367c-2.006-.125-4.027-.025-6.143-.025Z",
    transform: "translate(0 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    "data-name": "Caminho 544",
    className: "cls-2",
    d: "M180.789,160.5c.6,2.3,1.344,4.494,1.736,6.75a33.11,33.11,0,0,1,.791,7.862c-.354,5.024-4.905,8.541-10.089,8.251a9.4,9.4,0,0,1-8.827-9.317,42.492,42.492,0,0,1,2.418-12.377c.114-.344.224-.69.405-1.247a15.244,15.244,0,0,0-5.456,22.98c1.7,2.3,1.611,4-.418,6.035q-3.644,3.649-7.3,7.292c-2.123,2.107-4.419,1.992-6.367-.295-17.011-19.964-6.174-50.99,19.6-56.114A34.393,34.393,0,0,1,208.062,169.7a33.582,33.582,0,0,1-7.844,26.706c-1.962,2.374-4.268,2.449-6.437.285q-3.61-3.6-7.21-7.221c-2.094-2.1-2.206-3.741-.427-6.108A15.249,15.249,0,0,0,181.8,161.05c-.315-.188-.646-.349-1.015-.549Zm16.121,33.818c10.468-11.7,9.9-29.51.107-40.178l-8.065,8.1a19.251,19.251,0,0,1-.081,23.9c2.713,2.762,5.355,5.451,8.038,8.182Zm-45.959-40.255c-10.4,11.255-9.957,29.546-.015,40.141l7.981-8.065c-5.587-8.03-5.563-16.087.018-24.058Zm2.949-2.988,7.808,7.885c2.275-1.051,4.5-2.062,6.7-3.118a1.591,1.591,0,0,0,.7-.771c.46-1.1.822-2.244,1.278-3.346a3.793,3.793,0,0,1,7.1-.007c.443,1.067.8,2.171,1.229,3.245a1.476,1.476,0,0,0,.54.781c2.3,1.1,4.622,2.16,6.927,3.224l7.851-7.839c-10.969-10.154-29.19-10.152-40.13-.053Zm20.07,2.067c-.208.465-.292.619-.348.784-1.176,3.42-2.494,6.8-3.476,10.272a58.706,58.706,0,0,0-1.889,9.178,5.741,5.741,0,0,0,6.824,6.352,5.935,5.935,0,0,0,4.556-6.65c-.68-6.872-3.255-13.209-5.666-19.936Z",
    transform: "translate(-116.502 -116.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    "data-name": "Caminho 545",
    className: "cls-3",
    d: "M212.888,527.075h-24a8.177,8.177,0,0,1-1.12-.028,1.9,1.9,0,0,1-.069-3.751,6.646,6.646,0,0,1,1.118-.04h48.229a6.859,6.859,0,0,1,1.008.028,1.9,1.9,0,0,1-.041,3.769,9.046,9.046,0,0,1-1.12.023h-24Z",
    transform: "translate(-155.477 -437.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    "data-name": "Caminho 546",
    className: "cls-4",
    d: "M204.741,619.914c-5.232,0-10.465.01-15.7-.015a2.445,2.445,0,0,1-1.575-.351,2.6,2.6,0,0,1-.768-1.8c.049-.53.652-1.092,1.145-1.466a2.361,2.361,0,0,1,1.3-.189q15.584-.012,31.169-.007c.224,0,.45-.01.672.008a1.959,1.959,0,0,1,1.959,1.912,1.9,1.9,0,0,1-2.059,1.894c-4.41.021-8.819.012-13.231.012h-2.916Z",
    transform: "translate(-155.944 -514.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    className: "cls-5",
    d: "M362.1,573.485q-5.488,0-10.974,0c-1.532,0-2.4-.685-2.407-1.878s.888-1.939,2.367-1.94q11.03-.01,22.06,0c1.5,0,2.354.735,2.334,1.957-.02,1.179-.837,1.858-2.295,1.861q-5.542.012-11.086,0Z",
    transform: "translate(-291.277 -475.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    className: "cls-6",
    d: "M197.55,573.472c-3.028,0-6.055.007-9.083,0-1.468,0-2.283-.67-2.311-1.848-.028-1.229.82-1.968,2.323-1.97q9.14-.012,18.278,0c1.413,0,2.3.735,2.336,1.87.035,1.189-.86,1.944-2.349,1.947-3.065.008-6.129,0-9.195,0Z",
    transform: "translate(-155.492 -475.812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonfire);
export default __webpack_public_path__ + "static/media/icon-bonfire.4ea172d7134c816a1d60b65b9ed4e729.svg";
export { ForwardRef as ReactComponent };